const configuration = {
  configuration: {
    generalData: "Datos generales",
    organizationName: "Nombre de la organización",
    industryType: "Tipo de industria",
    language: "Idioma",
    languages: {
      en: "Inglés",
      es: "Español",
      pr: "Portugués",
      pt: "Portugués",
    },
    newValue: "Nuevo valor",
    newValueLengs: {
      es: "Nuevo valor",
      en: "New value",
      pt: "Novo valor",
    },
    segmentRequired: "Complete al menos un campo de idioma",
    country: "Pais",
    title: {
      general: "General",
      dataAnalysis: "Análisis de datos",
      preferences: "Configuración de envíos",
    },
    timezone: "Zona horaria",
    integrations: {
      title: "Integraciones",
      description:
        "Puedes customizar las configuraciones de tus integraciones.",
    },
    sendPreferences: {
      title: "Canales de comunicación",
      description:
        "Puedes cambiar las preferencias y canales para la comunicación",
      slack: "Permitir envio de interacciones a través de Slack",
      slackTooltip: "Debes estar conectado a Slack para activar esta opción",
      mail: "Permitir envio de interacciones a través de Mail",
      msTeams: "Permitir envio de interacciones a través de MS Teams",
    },
    onboarding: {
      title: "Onboarding",
      description: "Puedes elegir el tipo de onboarding",
      onboardingSwitch: {
        title: "Activar onboarding para colaboradores nuevos",
        input: "Selecciona la encuesta",
      },
      infoDaysSwitch: {
        title: "Retrasa la participación de las micro encuestas",
        input: "Selecciona los días",
      },
      selectInfoSwitch: {
        title: "Pedir información personal al incio del onboarding",
        input: "Selecciona las propiedades",
        teamsInfo: "Pedir informacion sobre equipo",
        tooltip:
          "Para pedir información personal al inicio del onboarding necesitas tener el onboarding activado",
      },
      tabs: {
        all: "Todos",
        bozTemplates: "Plantillas Boz",
        templates: "Plantillas",
      },
      selectAll: "Seleccionar todo",
      standards: "Estándares",
      personalizated: "Personalizadas",
      other: "Otros",
      modal: {
        title: "Confirmar nueva configuración",
        content:
          "¿Está seguro de que desea guardar esta nueva configuración para los futuros colaboradores?",
      },
    },
    recognitionsPreferences: {
      title: "Reconocimientos",
      description: "Configura la frecuencia del reporte de reconocimientos",
      businessRecognitions: "Reconocimientos por empresas",
      teamRecognirions: "Reconocimientos por equipo",
      automaticSendRecognitions: "Envío automático de reconocimientos",
      active: "Activo",
      inactive: "Inactivo",
      addValue: "Agregar valor",
      settingChannel: "Activar Reconocimientos Públicos",
      settingSchedule: "Asignar hora de envío de reconocimientos",
      realTime: "Tiempo real",
      hour: "Hora",
      saveMessage: "Preferencias de envío de reconocimientos guardado",

      sendRecognitionRequestCta: "Enviar pedido de reconocimientos",
      sendRecognitionReportCta: "Enviar reporte de reconocimientos",
      recognizableUsers:
        "Se enviara pedido de reconocimiento a {{total}} colaboradores",
      reportableUsers: "Se enviará un mensaje a los colaboradores reconocidos",
      recognitionRequestSent: "Pedido de reconocimientos enviado exitosamente",
      recognitionReportSent: "Reporte de reconocimientos enviado exitosamente",
      repeatedRecognitionValues:
        "Tienes valores de reconocimiento o íconos repetidos",
      repeatedRecognitionValuesBackCta: "Volver",
      recogntionValueLength: "{{length}} caracteres de máximo {{total}}",
      recognitionValuesSave: "¿Seguro de que quieres guardar la configuración?",
      recognitionValuesSaveWarning:
        "¿Estás seguro de que quieres modificar las categorías?",
      recognitionValuesSaveSubtitle:
        "Si haces esto, dejarás de ver las que elimines y se agregarán las nuevas. Verás las últimas categorías asignadas",
      recognitionValuesSaveCta: "Guardar",
      recognitionValuesCancelCta: "Cancelar",
      tooltipDisableButton:
        "Para utilizar el pedido manual de reconocimiento, primero debes deshabilitar el envío automático de reconocimiento",
      notSendRequestModal: {
        title: "El envío automático de reconocimiento esta activado",
        subtitlePartOne:
          "Para enviar un reconocimiento manual, desactiva el envío de renococimiento automático en configuraciones o haciendo ",
        subtitlePartTwo: " e intenta nuevamente",
        clickHere: "click aquí",
      },
      sendRequestModal: {
        title:
          "El pedido de reconocimientos se enviara ahora a {{numberOfUsers}} colaboradores",
        subtitle:
          "Seleccione la fecha y hora de envío del reporte de reconocimientos",
      },
      someRecognitionWhenSent:
        "Ya se ha enviado un pedido de reconocimiento este mes",
      loadCustomEmoji: "Cargar emojis de valores personalizados",
    },
    emojiLoader: {
      title: "Importa tus emojis",
      explanation:
        "Es mejor usar imágenes cuadradas de menos de 128 KB, que tengan fondo transparente de tipo png, jpg o jpeg. Si tu imagen es demasiado grande, intentaremos cambiarle el tamaño",
      errorType: "El tipo de imagen no es el adecuado!",
      saveSuccess: "Emoji guardado con exito!",
      saveError:
        "No se pudo guardad el emoji, reintenta nuevamente o contacta con soporte",
    },
    maxRecognition: {
      monthlyRecognitions: "Cantidad de reconocimientos mensual",
      maximumPerColaborator: "Máximo por colaborador",
      nRecognitions: "{{ nRecognitions }} reconocimientos",
      unlimited: "Sin limite",
    },
    surveys: {
      surveyTitle: "Programa tus encuestas",
      frequency: "Frecuencia de envío de encuestas",
      preferSchedule: "Horario preferido de envío",
      preferenceDays: "Días de envío",
      questionQuantity: "Cantidad de preguntas",
    },
    slack: {
      connect: "Conectar con Slack",
      alreadyConnected: "Ya estás conectado a Slack",
      automaticTeamJoin: "Añadir usuarios nuevos automáticamente",
      automaticInfoUpdate: "Actualización automática de los usuarios",
      tooltips: {
        automaticTeamJoin:
          "Si está encendido, cada vez que una persona nueva ingrese a tu espacio de trabajo en Slack, se agregará automáticamente a Burnout-Zero",
        automaticInfoUpdate:
          "Si está encendido, mantendrá sincronizada la información de los usuarios cada vez que la cambien en Slack (foto, nombre, etc)",
      },
    },
    breadcrumbs: {
      settings: "Configuración",
      properties: "Propiedades",
      organizationDetails: "Detalles de la organización",
      integrations: "Integraciones",
      sendPreferences: "Canales de comunicación",
      recognitionsPreferences: "Reconocimientos",
      segments: "Segmentos",
      newSegment: "Nuevo segmento",
      birthdayBot: "BirthdayBoz",
      onboarding: "Onboarding",
      timeOff: "Tiempo libre",
      createTimeoff: "Crear política",
      editTimeOff: "Editar política",
      newTimeOff: "Agregar Colaboradores",
      publicApi: "Integración API",
    },
    teams: {
      connect: "Conectar con MS Teams",
      alreadyConnected: "Ya estás conectado a Microsoft Teams",
      upgradeIntegration: "Actualizar integración",
      upgradingIntegration: "Actualizando integración",
      updatePermissions: "Actualizar permisos",
      upgradeSuccesful: "Actualización exitosa",
      setPermissions: "Autorizar nuevos permisos",
      backToHome: "Volver al inicio",
    },
    sections: {
      general: {
        name: "General",
        subsections: {
          details: {
            name: "Detalles de la organización",
            description:
              "Actualiza la información de tu organización e idioma.",
          },
          integrations: {
            name: "Integraciones",
            description: "Revisa el estado de tus integraciones.",
          },
        },
      },
      preferences: {
        name: "Configuración de envíos",
        subsections: {
          sendPreferences: {
            name: "Canal de comunicación",
            description: "Configura el canal de envío para tus comunicaciones.",
          },
          recognitions: {
            name: "Reconocimientos",
            description:
              "Configura tus valores organizacionales a la hora de reconocer.",
          },
          calendar: {
            name: "Calendario",
            description:
              "Configura la frecuencia y configuración de tus envíos.",
          },
          birthdayBot: {
            name: "BirthdayBoz",
            description: "¡Que nunca más se te pase un cumpleaños!",
          },
          onboarding: {
            name: "Onboarding",
            description: "Configura el onboarding para colaboradores nuevos.",
          },
        },
      },
      data: {
        name: "Análisis de datos",
        subsections: {
          properties: {
            name: "Propiedades",
            description:
              "Crea y edita propiedades para segmentar a tus colaboradores.",
          },
          filters: {
            name: "Segmentos",
            description:
              "Segmenta a tus colaboradores para analizar en base a tus criterios.",
          },
        },
      },
    },
    properties: {
      title: "Propiedades",
      description:
        "Tienes que crear una propiedad primero para segmentar a los miembros de tu organización.",
      searchBar: {
        placeholder: "Busca una propiedad",
      },
      table: {
        headers: {
          name: "Nombre",
          type: "Tipo",
          createdBy: "Creado por",
          category: "Categoría",
        },
        badge: {
          custom: "Personalizada",
          standard: "Estándar",
        },
        types: {
          Date: "Fecha",
          Options: "Opciones",
          Numeric: "Numérico",
          Text: "Texto",
        },
        buttons: {
          delete: "Borrar propiedad",
          edit: "Editar propiedad",
        },
      },
      createProperty: {
        title: "Nueva propiedad",
        description:
          "Esto te permitirá segmentar los miembros de tu organización",
        name: "Nombre de la propiedad",
        type: "Tipo de la propiedad",
        values: "Valores de la propiedad",
        placeholder: "Ej: Desarrollo",
        addValue: "Agregar nuevo valor",
        create: "Crear propiedad",
        nameError: "Ingresa un nombre para la propiedad",
      },
      assignProperties: {
        button: "Asignar",
        body: {
          title: "Asignar propiedades a usuarios",
          tipsTitle: "Antes de subir la planilla, asegurate que:",
          tipOne: "Las propiedades de tipo fecha vengan en formato AAAA/MM/DD.",
          tipTwo:
            "Las propiedades de tipo númerico sean un número entero sin decimales.",
          tipThree:
            "Para las propiedades de tipo opción, que el valor que ingresas efectivamente está creado dentro de la propiedad (ej: Masculino).",
          downloadExample: "Descargar plantilla ejemplo",
          upload: "Subir propiedades",
          loading: "Esto puede tomar unos segundos",
        },
      },
      propertiesValidationError: {
        title: "Hubo un error",
        caption: "Revisa lo siguiente",
        invalid: "Propiedades no existentes",
        valid: "Propiedades correctas",
        tip: "Revisa que las propiedades no existentes estén creadas en la cuenta y/o que estén bien escritas en la planilla.",
        retry: "Reintentar",
      },
      editProperty: {
        title: "Editar propiedad",
        description:
          "Puedes cambiar solo el nombre de las propiedades existentes.",
        name: "Nombre de la propiedad",
        type: "Tipo de la propiedad",
        values: "Valores de la propiedad",
        typeForbidden: "No se permite cambiar el tipo de la propiedad",
        update: "Actualizar propiedad",
        addValue: "Agregar nuevo valor",
      },
      deleteProperty: {
        title: "¿Borrar esta propiedad?",
        description:
          "Si borras esta propiedad, todos los segmentos que tengan asociada esta propiedad se borrarán.",
        accept: "Aceptar",
        cancel: "Cancelar",
      },
      importResult: {
        title: "Resultado de la importación",
        email: "Email",
        rowNumber: "# de fila",
        retry: "Reintentar",
        resume:
          "Revisa el resultado de tu importación para que puedas corregir si hay errores:",
        NUMERIC_VALUE_INVALID: "El valor numérico ingresado es inválido",
        INVALID_OPTION_VALUE:
          "La opción ingresada como valor no existe en la propiedad",
        DATE_FORMAT_INVALID: "El formato de fecha ingresado es inválido",
        USER_DOESNT_EXIST: "El usuario ingresado no existe en la cuenta",
        EMAIL_EMPTY: "El campo email está vacío",
        VALUE_EMPTY: "El campo está vacío",
      },
    },
    organizationDetails: {
      title: "Detalles de la organización",
      description: "Puedes editar la información general de tu organización.",
    },
    segments: {
      title: "Segmentos",
      description:
        "Monitorea diferentes agrupaciones de miembros en función de rasgos y características comunes.",
      button: "Crear",
      table: {
        headers: {
          name: "Segmento",
          properties: "Propiedades",
          members: "Miembros",
        },
        tooltip:
          "Este segmento no estará disponible en los filtros al tener menos de 5 miembros activos.",
      },
      deleteModal: {
        title: "Borrar segmento",
        description: "¿Estás seguro que quieres eliminar este segmento?",
        accept: "Aceptar",
        cancel: "Cancelar",
      },
      conditions: {
        IS_BEFORE: "es antes de",
        IS_EXACTLY: "es exactamente",
        IS_AFTER: "es después de",
        IS_EQUAL_TO: "es igual a",
        IS_NOT_EQUAL_TO: "no es igual a",
        IS_LESSER_THAN: "es menor a",
        IS_GREATER_THAN: "es mayor a",
      },
      viewSegment: {
        property: "Propiedad",
        condition: "Condición",
        value: "Valor",
      },
    },
    newSegment: {
      title: "Crea un nuevo segmento",
      description:
        "Usa segmentos para agrupar tus colaboradores en base a tus propiedades.",
      emptyState: {
        title: "Crea segmentos para identificar tendencias de grupo",
        description:
          "Puedes monitorear diferentes grupos de colaboradores en base a sus características y rasgos comunes.",
        button: "Quiero saber más",
      },
      createForm: {
        name: {
          label: "Nombre del segmento",
          placeholder:
            "Elige un nombre para el segmento, ej: Hombres menores de 30",
        },
        rules: {
          title: "Reglas y propiedades",
          select: {
            all: "Todas",
            any: "Cualquiera",
            hasTo: "Tiene que cumplir",
            following1: "las siguientes",
            following2: "de las siguientes",
          },
        },
        propertyRules: {
          property: "Propiedad",
          condition: "Condición",
          value: "Valor",
          add: "Agregar nueva regla",
          button: "Crear segmento",
          nameHelperText: "Ingresa un nombre para el segmento",
          alerts: {
            noUsers:
              "No hay usuarios asociados a este segmento. Intenta modificar o agregar reglas.",
            oneUser:
              "Solo hay {{active}} usuario activo asociado a este segmento y {{inactive}} usuarios inactivos",
            lessThanFiveUsers:
              "Solo hay {{active}} usuarios activos asociados a este segmento y {{inactive}} usuarios inactivos.",
            ok: "OK! Hay {{active}} usuarios activos y {{inactive}} usuarios inactivos asociados a este segmento.",
          },
        },
      },
    },
    birthdayBot: {
      title: "BirthdayBoz",
      description: "Configura tu bot cumpleañero.",
      activate: "Activar bot cumpleañero",
      birthdays: "Enviar cumpleaños",
      anniversaries: "Enviar aniversarios de trabajo",
      selectGroup: "Elige tu equipo de envío",
      textToLoad: "Carga tus aniversarios y cumplaños con Excel",
      selectChannel: "Elige tu canal de envío",
      selectSchedule: "Elige tu horario de envío",
      disclaimer: "*El mensaje se enviará según la zona horaria de la cuenta",
      informativeParagraph:
        "¡Le invitamos a configurar la zona horaria de su cuenta para acceder a las celebraciones de Birthday BOZ. Por favor, haga clic ",
      here: "aquí!",
      upload: {
        title: "Asignar aniversarios y cumpleaños a usuarios",
        subTitle: "Información importante sobre BirthdayBOZ :",
        paragraph1:
          "Las fechas se deben ingresar en formato AAAA/MM/DD en tipo de texto.",
        paragraph2:
          "Los usuarios también podrán cargar sus fechas desde el canal de comunicación, reemplazando las fechas importadas a través de la planilla.",
        paragraph3:
          "Cada día en el que se cumpla un cumpleaños o aniversario, BirthdayBOZ enviará un mensaje de celebración automatízado al canal seleccionado.",
        file: "Subir archivo",
        results: "Resultados de importación",
        tryAgain: "Importar de nuevo",
        button: "Cargar fechas con Excel",
        errors: {
          INVALID_DATE: "Fecha inválida",
          USER_DOESNT_EXIST: "Usuario no existe en la cuenta",
        },
        headers: {
          row: "N° de fila",
          email: "Email",
          comments: "Comentarios",
        },
      },
    },
    newTimeOff: {
      title: "Agregue colaboradores para la política",
      description: "Siempre puede volver para modificar los colaboradores",
      titleModal: "Estas creando una nueva política",
    },
    timeOff: {
      title: "Tiempo libre",
      description: "Crea tus políticas de tiempo libre",
      button: "Crear política",
      name: "Nombre de la política",
      type: "Tipo de política",
      payType: "¿Aplica la remuneración a estas vacaciones?",
      quantityOfCollabs: "Cantidad de colaboradores",
      addCollabs: "Agregar colaboradores",
      save: "Guardar",
      edit: "Editar política",
      delete: "Eliminar política",
      setDyas: "Fijar tipo de dias",
      fixedDays: "Cantidad de dias",
      initialDays: "Dias iniciales",
      additionalDays: "Dias por mes trabajado",
      prorated: "¿Prorratear política?",
      notice: "Minimo de dias para pedir el tiempo libre",
      autoAdd: "Agregar automaticamente a nuevos colaboradores",
      editTitle: "Edite las caracteristicas de la política",
      filterByName: "Filtrar por nombre",
      filterByMail: "Filtrar por mail",
      selectFilters: "Seleccionar filtros",
      selectAll: "Seleccionar todo",
      segments: "Segmentos",
      teams: "Equipos",
      typeOfPolicy: {
        legal: "Legal",
        administrative: "Administrativa",
        additional: "Adicional",
      },
      typeOfPayment: {
        paid: "Paga",
        noPaid: "No paga",
      },
      typeOfSetDays: {
        fixed: "Fijos",
        dynamic: "Dinamicos",
        unlimited: "Ilimitados",
      },
      yesOrNo: {
        yes: "Si",
        no: "No",
      },
      view: {
        title: "Detalle de la política",
        caption: "Solo podra ver, no podra editar aca.",
        name: "Nombre",
        mail: "Mail",
        noTeam: "Sin equipo",
        group: "Equipo",
      },
      deleteSucces: "Política eliminada",
      updateSucces: "Política actualizada",
      editPolicy: "Editar política",
      deletePolicy: "Eliminar política",
      empty: "NO HAY POLÍTICAS CREADAS",
      emptyDescription:
        "Parece que aún no has configurado ninguna política de vacaciones.",
      emptyDescription2: "¡Es fácil! Haz clic en el botón para crear una.",
      editModal: {
        title: "Edite las caracteristicas de la política",
      },
      deleteModal: {
        title: "Borrar política",
        caption: "Al confirmar se eliminará esta política",
        caption2:
          "Si hay políticas que dependan de la política que estás eliminando, esta dependencia dejará de existir",
      },
      new: {
        title: "Cree las condiciones de la política",
        create: "Crear política",
        accumulative: "Acumulativa",
        accumulativeTooltip:
          "Cuando la política es acumulativa, la cantidad ingresada de dias se ira sumando a los dias disponibles, en la fecha que configure.",
        selectDateType: "Fecha de renovacion",
        selectDate: "Seleccione mes y día de renovación",
        hiringDate: "Fecha de contratación",
        fixed: "Fija",
        doubleApproval: "Requiere doble aprobación",
        doubleApprovalTooltip:
          "Cuando está activado, las solicitudes de tiempo libre necesitarán ser aprobadas dos veces. La segunda aprobación se solicitará a través del canal de Slack seleccionado",
        policyDependency: "Depender de otra política",
        policyDependencyTooltip:
          "Cuando está activado, esta política solo estará disponible si el usuario ha utilizado todos los días disponibles de la política seleccionada",
        selectDependencyPolicy: "Seleccionar política de dependencia",
        selectSlackChannel: "Seleccionar canal de Slack",
        slackChannel: "Canal de Slack",
      },
      groups: "Equipos",
      noSegment: "Sin segmento",
      add: {
        title: "Nombre de la política que està modificando: ",
        filters: {
          byName: "Filtre por nombre",
          byMail: "Filtre por mail",
          byOthers: "Selecionar equipos/segmentos",
        },
        name: "Nombre",
        mail: "Mail",
        group: "Equipo",
        segment: "Segmento",
        filter: "Filtrar",
        info: "Solo se podra agregar a los colaboradores que tengan una fecha de contratación. Puede modificar la fecha de contratación en la planilla.",
      },
      setDays: {
        tooltip:
          "Fijos: Asigna una cantidad específica de días a todos los empleados agregados.\nDinámico: Asigna una cantidad de días variable según la fecha de inicio de cada empleado.\nIlimitados: Sin límite",
      },
      days: "Días",
      unlimited: "Dias ilimitados",
      tooltip: "No se suman los dias de políticas ilimitadas.",
    },
    createTimeoff: {
      title: "Nueva política",
      description: "Cree las condiciones de la política",
      button: "Crear",
    },
    editTimeOff: {
      title: "Editar política",
      description: "Edita las caracteristicas de la política",
      button: "Editar política",
    },
    publicApi: {
      title: "Integración API",
      description:
        "Administra tus credenciales para integrarte a la API de Burnout-Zero",
      createApiKey: "Crear API Key",
      delete: "Eliminar API key",
      deleteConfirmation:
        "Al eliminar este API key este dejara de funcionar en las integraciones donde este siendo utilizada, esta seguro?",
      deleteSucess: "API key borrado exitosamente",
      deleteError: "Error borrando API key",
      noKeys: "Aún no se han creado claves API",
      table: {
        headers: {
          name: "Nombre API key",
          clientId: "Client ID",
          createdAt: "Fecha de creación",
        },
        buttons: {
          viewSecret: "Ver client secret",
        },
      },
      viewClientSecret: {
        title: "Client secret",
        hide: "Ocultar",
        reveal: "Ver",
        copy: "Copiar",
      },
      form: {
        nameLabel: "Nombre API key",
        success: "API key creado exitosamente",
        error: "Error creating API key",
      },
    },
  },
};
export default configuration;
